/* eslint-disable react-hooks/exhaustive-deps */
import { FormControl, FormHelperText } from '@mui/material'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { get } from 'lodash'
import * as React from 'react'
import { Controller } from 'react-hook-form'

export interface AutoCompleteProps {
  entries?: [string, string] | any
  label: string
  form: any
  options?: any
  name: string
  mb: any
  groupBy?: string
}

const InputAutoComplete: React.FC<AutoCompleteProps> = (props) => {
  const {
    options,
    entries,
    label,
    form,
    name: inputName,
    groupBy,
    mb = 2,
  } = props
  const [text, setText] = React.useState('')
  const { watch } = form
  const [selected, setSelected] = React.useState(false)

  React.useEffect(() => {
    initValues()
  }, [options])

  React.useEffect(() => {
    const subscription = watch((value: any, { name, type }: any) => {
      if (!type) {
        initValues()
      }
    })

    return () => subscription.unsubscribe()
  }, [watch])

  const initValues = () => {
    const initialValue = get(form.getValues(), inputName)
    try {
      if (initialValue) {
        if (options[0]) {
          setText(
            options.find((item) => get(item, entries[0]) === initialValue)[
              entries[1]
            ],
          )
        } else {
          if (initialValue) {
            setText(String(initialValue))
          }
        }
        setSelected(false)
      } else {
        setText('')
      }

      selected === false && setSelected(true)
    } catch (error) {}
  }

  const filterOptions = selected
    ? (options: any) => options
    : createFilterOptions({
        matchFrom: 'start',
        stringify: (option: any) => get(option, entries[1]),
      })

  return (
    <Controller
      name={inputName}
      control={form.control}
      render={({
        field: { onChange, value, ...rest },
        fieldState: { error, ...state },
      }: any) => {
        const hasError = !!error
        return (
          <FormControl fullWidth error={hasError} sx={{ mb }}>
            <Autocomplete
              sx={{ width: '100%' }}
              options={options}
              size="small"
              disableClearable
              autoHighlight
              groupBy={(option) =>
                groupBy ? get(option, groupBy).toUpperCase() : ''
              }
              //renderGroup={()=><>Group Item</>}
              inputValue={text}
              onChange={(_, v) => {
                selected === false && setSelected(true)

                onChange(typeof v !== 'object' ? v : get(v, entries[0]))
                setText(typeof v !== 'object' ? v : get(v, entries[1]))
              }}
              getOptionLabel={(option: any) => {
                return typeof option !== 'object'
                  ? String(option)
                  : get(option, entries[1]) || ''
              }}
              isOptionEqualToValue={(option, value) => {
                if (typeof option !== 'object') {
                  return option === value
                } else {
                  return value !== '' && get(option, entries[0]) === value
                }
              }}
              renderOption={(p, option) => {
                return (
                  <Box
                    component="li"
                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                    key={option?.id}
                    {...p}
                  >
                    {typeof option !== 'object'
                      ? option
                      : get(option, entries[1])}
                  </Box>
                )
              }}
              filterOptions={filterOptions}
              renderInput={(params: any) => {
                return (
                  <TextField
                    {...params}
                    error={hasError}
                    label={label}
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      ...params.inputProps,
                      onChange: (e: any) => {
                        selected === true && setSelected(false)
                        setText(e.target.value)
                        if (!e.target.value) {
                          form.setValue(inputName, '')
                        }
                      },
                    }}
                  />
                )
              }}
              value={value || null}
            />
            {hasError && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )
      }}
    />
  )
}

export default InputAutoComplete
